export const enumeration = {
  areaTypes: [ // 区域类型
    {value: 1, label: '海关特殊监管区域'},
    {value: 2, label: ' 保税物流中心（B型）'},
  ],
  regionTypes: [ // 地区分类
    {value: 1, label: '东部地区'},
    {value: 2, label: '中部地区'},
    {value: 3, label: '西部地区'},
    {value: 4, label: '东北地区'},
    {value: 5, label: '西部和东北地区'}
  ],
  contentTypes: [ // 内容类型
    {value: 1, label: '新闻动态'},
    {value: 2, label: '重要活动'},
    {value: 3, label: '联盟公告'},
    {value: 4, label: '联盟新闻'},
    {value: 5, label: '成员风采'},
    {value: 5, label: '经贸促进'},
    {value: 5, label: '信息服务'},
    {value: 5, label: '商事法律服务'},
    {value: 5, label: '规则标准推广'}
  ],
  levelTypes: [
    {label: '国家', value: 'country'},
    {label: '省', value: 'province'},
    {label: '市', value: 'city'},
  ],
  aboutMenu: [
    {label: '陆海新通道介绍', value: 'land_sea_new_channel'},
    {label: '陆海新通道国际工商会联盟介绍', value: 'international_federation_of_chambers_of_commerce'},
    {label: '联盟成员单位介绍', value: 'alliance_member_units'},
    {label: '联盟秘书处介绍', value: 'alliance_secretariat'},
    {label: '联系方式', value: 'contact_us'},
  ],
  allianceMemberTypes: [
    {value: 1, label: '企业'},
    {value: 2, label: '机构'},
    {value: 3, label: '商会'},
  ],
  prioritys: [
    {value: 1, label: '联盟推荐'},
    {value: 2, label: '成员单位主板'},
  ],
  exhibitionTypes: [
    {value: '1', label: '国际展会'},
    {value: '2', label: '行业会议'},
    {value: '3', label: '贸易博览会'},
    {value: '4', label: '数字贸易峰会'},
  ],
}


// WEBPACK FOOTER //
// ./src/assets/js/enumeration.js